import React from 'react';

const convertSizeForIcon = (size) => {
  let iconSize = "sm";
  switch (size) {
    case "sm":
      iconSize = "xs";
      break;
    case "md":
      iconSize = "xs";
      break;
    case "lg":
      iconSize = "sm";
      break;
  }
  return iconSize;
};
const useChip = ({
  isChecked = false,
  isDisabled = false,
  isError = false,
  isLoading = false,
  kind = "solid",
  media,
  onDismiss,
  size
}) => {
  const iconSize = convertSizeForIcon(size);
  let MediaComponent;
  if (!!media && React.isValidElement(media)) {
    const mediaSize = size === "sm" ? "xxs" : "xs";
    MediaComponent = React.cloneElement(media, { size: mediaSize });
  }
  const handleDismiss = (event) => {
    event.stopPropagation();
    onDismiss == null ? void 0 : onDismiss(event);
  };
  let chipKind = kind;
  if (isChecked) {
    chipKind = kind === "solid" ? "outline" : "solid";
  }
  const showError = !!isError;
  const showDismiss = !isDisabled && !!onDismiss;
  const showProgress = !isError && !!isLoading;
  return { iconSize, MediaComponent, handleDismiss, chipKind, showError, showDismiss, showProgress };
};

export { useChip as default };
//# sourceMappingURL=useChip.es.js.map
